import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Carica la configurazione e poi monta l'app
fetch(process.env.BASE_URL + "config.json")
  .then((response) => response.json())
  .then((config) => {
    
    const appInstance = createApp(App);
    appInstance.use(store);
    appInstance.use(router);
    appInstance.provide("cfg", config);
    appInstance.mount("#app");
            
  })
